<template>
    <b-row>
        <b-col>
            <b-table striped hover :items="players" :fields="fields">
            <template slot="kartengeber" slot-scope="data">
                <div v-if="gamestarted">
                    <b-button variant="success" v-if="isKartengeber(data.index)">
                        <font-awesome-icon icon="user"/>
                    </b-button>
                </div>
            </template>
            <template slot="phase" slot-scope="data">
                <p :class="`phaseBox phase${data.item.phase}`">
                    {{data.item.phase}}
                </p>
                <font-awesome-icon v-if="editMode" icon="arrow-up" @click="phaseUp(data.index)"/>
                <font-awesome-icon v-if="editMode" icon="arrow-down" @click="phaseDown(data.index)"/>
            </template>
            <template slot="points" slot-scope="data">
                {{data.item.points}}
                <font-awesome-icon v-if="editMode" icon="edit" @click="editPlayer = data.index" v-b-modal="'editPoints'" />            
            </template>
            </b-table>
            <div class="text-center">
                <b-btn class="mt-1" v-b-modal="'myModal'" v-if="gamestarted">Runde beenden</b-btn>
                <b-btn class="mt-1 ml-1" v-if="gamestarted" @click="$store.dispatch('toggleEditMode')">Edit Mode</b-btn>
            </div>
        </b-col>
        <b-modal id="editPoints" @ok="updatePlayer" v-if="gamestarted">
          <b-form-input v-if="players[editPlayer]" v-model.number="players[editPlayer].points"
              type="text"
              placeholder="Spielerpunkte setzen">
          </b-form-input>
        </b-modal>
        <b-modal id="myModal" @ok="finishRound">
            <b-list-group>
            <b-list-group-item v-bind:key="player.index" v-for="(player, index) in players">
                <b-input-group>
                    <p class="mr-1">{{player.name}}</p>
                    <b-form-input v-model.number="form.points[index]"
                        type="text"
                        placeholder="Enter Points"
                        class="pointInput mr-1" ></b-form-input>
                    <b-form-checkbox v-model="player.round_done"
                                    value="ok">
                        Runde geschafft
                    </b-form-checkbox>
                </b-input-group>
            </b-list-group-item>
            </b-list-group>
        </b-modal>
    </b-row>
</template>

<script>
export default {
  name: 'PlayerList',
   data () {
    return {
      form: {
       playername: '',
       selected: '',
       points: [],
      },
      editPlayer: 0,
      fields: [{ key: 'name', label: 'Name' }, { key: 'phase', label: 'Phase' }, { key: 'points', label: 'Punkte' }, 'kartengeber'],
    }
  },
  computed: {
      gamestarted() {
          return this.$store.getters.gameStarted
      },
      players: function() {
          return this.$store.getters.players
      },
      editMode: function() {
          return this.$store.getters.editMode 
      }
  },
  methods: {
    isKartengeber (index) {
        return index == this.$store.getters.kartengeber
    },
    phaseUp(index) {
        const player = this.players[index]
        player.phase++
        this.$store.dispatch('updatePlayer', player)
    },
    phaseDown(index) {
        const player = this.players[index]
        player.phase--
        this.$store.dispatch('updatePlayer', player)
    },
    updatePlayer(player) {
        this.$store.dispatch('updatePlayer', player)
    },
    finishRound() {
        let roundStatus = [];
        this.players.forEach((player, index) => {

            const roundDone = (player.round_done == "ok"? true: false)
            const pointsToAdd = (this.form.points[index] == null ? 0 : parseInt(this.form.points[index]));

            roundStatus[player.name] = {roundDone: roundDone, points: pointsToAdd}
        
            player.round_done = false
            this.form.points[index] = 0
        })

        this.$store.dispatch('finishRound', roundStatus)        
    },
  }
}
</script>

<style lang="scss">
   .phaseBox {
        border: 1px solid;
    }
    .phase1 {
        background-color: yellow;
    }
    .phase2 {
        background-color: orange;
    }
    .phase3 {
        background-color: red;
    }
    .phase4 {
        background-color: pink;
    }
    .phase5 {
        background-color: lightgreen;
    }
    .phase6 {
        background-color: darkgreen;
    }
    .phase7 {
        background-color: lightblue;
    }
    .phase8 {
        background-color: violet;
    }
    .phase9 {
        background-color: brown;
    }
    .phase10 {
        background-color: white;
    }
    .pointInput {
        width: 50%;
        text-align: center;
    }
</style>